import React, { Component } from 'react';
import { TextField } from '@material-ui/core';

export default class FormInputText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: this.props.defaultValue
        };
        this.handleChange = this.handleChange.bind(this);
    }
    
    handleChange = (event) => {
        let value = event.target.value;
        this.setState({ defaultValue: value });
    }
     
    render() {

        const { id, label, classnamecustom, name, placeholder, type } = this.props;
        return (
            <TextField fullWidth InputLabelProps={{ shrink: true }} variant="outlined"
                className={`InputForm ${classnamecustom}`}
                //{...this{.props}
                InputProps={{ inputProps: { min: 1, max: 29 } }}
                id={id}
                label={label}
                placeholder={placeholder}
                required onChange={this.handleChange}
                value={this.state.defaultValue}
                name={name}
                type={type}
                disabled={this.props.disabled}
                size='small'
            />
        )
    }
}
